'use strict';

export default angular.module('fplTruescapeComApp.progressBarDirective', [])
  .directive('progressBar', () => {
    return {
      restrict: 'EA',
      scope: {
        progress: '='
      },
      template: require('./progressBar.html')
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/progressBar/progressBar.directive.js